import { LazyExoticComponent, lazy, useEffect } from 'react'

type LazyWithPreloadComponent = LazyExoticComponent<any> & {
  preload: () => void
}

type DynamicImport = () => Promise<{ default: React.ComponentType<any> }>

export const lazyWithPreload = (importStatement: DynamicImport) => {
  const Lazy = lazy(importStatement) as LazyWithPreloadComponent
  Lazy.preload = importStatement
  return Lazy
}

export const usePreloadLazy = (components: LazyWithPreloadComponent[]) =>
  useEffect(() => {
    components.forEach((component) => component.preload())
  }, [])
